import { Outlet, NavLink } from "react-router";
import { DM_ROLES, ImpersonationSwitcher, RequiresRole, useCurrentUser } from "src/dm/auth";
import Breadcrumb from "src/dm/components/Breadcrumb/Breadcrumb";
import * as s from "./AppLayout.css";

const AppLayout = () => {
  const { data: user } = useCurrentUser();

  return (
    <div className={s.shell}>
      <header className={s.header}>
        <div className={s.brand}>Deal Central</div>
        <nav className={s.nav}>
          {/*
            NavLink does NOT forward arbitrary `data-*` function props — it
            calls the function then sets `data-active="(function …)"` on the
            DOM, which React rejects with "Invalid value for prop". Audit
            25-parity-roundtrip-2 §D-4. Instead, drive the active style via
            NavLink's own `className` function (which IS supported) and
            append the `active` modifier; the underlying CSS rule keys off
            an actual data-attribute we set ourselves below via a className
            selector — much cleaner.
          */}
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `${s.navLink}${isActive ? ` ${s.navLinkActive}` : ""}`
            }
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/dm/search"
            className={({ isActive }) =>
              `${s.navLink}${isActive ? ` ${s.navLinkActive}` : ""}`
            }
          >
            Search
          </NavLink>
          <NavLink
            to="/dm/new"
            className={({ isActive }) =>
              `${s.navLink}${isActive ? ` ${s.navLinkActive}` : ""}`
            }
          >
            New Deal
          </NavLink>
          <RequiresRole roles={[DM_ROLES.Auditor, DM_ROLES.Admin]}>
            <NavLink
              to="/dm/audit"
              className={({ isActive }) =>
                `${s.navLink}${isActive ? ` ${s.navLinkActive}` : ""}`
              }
            >
              Audit
            </NavLink>
          </RequiresRole>
          <RequiresRole roles={[DM_ROLES.Admin, DM_ROLES.ItAdmin]}>
            <NavLink
              to="/dm/admin"
              className={({ isActive }) =>
                `${s.navLink}${isActive ? ` ${s.navLinkActive}` : ""}`
              }
            >
              Admin
            </NavLink>
          </RequiresRole>
          <NavLink
            to="/dm/preferences"
            className={({ isActive }) =>
              `${s.navLink}${isActive ? ` ${s.navLinkActive}` : ""}`
            }
          >
            Preferences
          </NavLink>
          <NavLink
            to="/dm/preferences/dashboard"
            className={({ isActive }) =>
              `${s.navLink}${isActive ? ` ${s.navLinkActive}` : ""}`
            }
          >
            Customize Dashboard
          </NavLink>
          {/*
            audit/22-screenshot-inventory.md §1 MINOR #1 — legacy top-nav
            had `Help` and `E-Learning` links to external GE Wiki /
            Confluence pages. We don't have the URLs in this build, so
            stub them as anchors targeting `#` with a title-attribute
            TODO. The visual presence keeps parity for users who scan the
            nav for these entries; the no-op click is a known-acceptable
            placeholder until ops supplies the URLs.
          */}
          <a
            href="#"
            className={s.navLink}
            // TODO: point at the GE Wiki Deal Central Help page.
            title="Help"
            onClick={(e) => e.preventDefault()}
          >
            Help
          </a>
          <a
            href="#"
            className={s.navLink}
            // TODO: point at the Confluence E-Learning training portal.
            title="E-Learning"
            onClick={(e) => e.preventDefault()}
          >
            E-Learning
          </a>
        </nav>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <ImpersonationSwitcher />
          <div className={s.userChip}>{user?.fullName ?? user?.qualifiedUserId ?? "local dev"}</div>
        </div>
      </header>
      <Breadcrumb />
      <main className={s.main}>
        <Outlet />
      </main>
      <footer className={s.footer}>
        Deal Central — local development build
      </footer>
    </div>
  );
};

export default AppLayout;
